import { IFinanceResponce, IFinancialInfoMaterialsResponse, IFundraisingReport, IProductResponce, ReportValidation } from './index';
import { ReportState } from './state';
import { getStoreAccessors } from 'typesafe-vuex';
import { State } from '../state';
import { Report, ReportData } from '@/interfaces/report';
import { IMaterial } from '@/interfaces';

export const mutations = {
    setReportValidation(state: ReportState, payload: ReportValidation) {
        state.report_validation = payload;
    },
    setProduct(state: ReportState, payload: IProductResponce) {
        state.product = payload;
    },
    setProductMaterials(state: ReportState, payload: IMaterial[]) {
        if (state.product) state.product.materials = payload;
    },
    setFinance(state: ReportState, payload: IFinanceResponce) {
        state.finance = payload;
    },
    setFinanceMaterials(state: ReportState, payload: IMaterial[]) {
        if (state.finance) state.finance.materials = payload;
    },
    setFinancialInfoMaterials(state: ReportState, payload: IFinancialInfoMaterialsResponse) {
        state.financialInfoMaterials = payload;
    },
    setFundraisings(state: ReportState, payload: IFundraisingReport) {
        state.fundraising = payload;
    },
    setReportData(state: ReportState, payload: ReportData) {
        state.reportData = payload;
    },
    setReports(state: ReportState, payload: Report[] | null) {
        state.reports = payload;
    },
    setReportId(state: ReportState, payload: number | null) {
        state.report_id = payload;
    },
};

const { commit } = getStoreAccessors<ReportState | any, State>('');

export const commitSetReportValidation = commit(mutations.setReportValidation);
export const commitSetProduct = commit(mutations.setProduct);
export const commitSetProductMaterials = commit(mutations.setProductMaterials);
export const commitSetFinance = commit(mutations.setFinance);
export const commitSetFinanceMaterials = commit(mutations.setFinanceMaterials);
export const commitSetFinancialInfoMaterials = commit(mutations.setFinancialInfoMaterials);
export const commitSetFundraisings = commit(mutations.setFundraisings);
export const commitSetReportData = commit(mutations.setReportData);
export const commitSetReports = commit(mutations.setReports);
export const commitSetReportId = commit(mutations.setReportId);